// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__248w8","item":"PaymentsMobile_item__DXeU7","label":"PaymentsMobile_label__3V2S-","amount":"PaymentsMobile_amount__3Dw_Z"};